let bookCheck = document.querySelector(".Book__txtConfirm input"),
    bookBtn = document.querySelector(".Book__txtBtn")

const watchCheckBox = () => {
    if (bookCheck.checked) {
        bookBtn.classList.add("clickable")
    } else {
        bookBtn.classList.remove("clickable")
    }
}

bookCheck.addEventListener("change", () => {
    watchCheckBox()
})

export const bookReset = () => {
    bookCheck.checked = false
    watchCheckBox()
    setTimeout(() => {
        document.querySelector(".Book .Modal__innerBlock .simplebar-content-wrapper").scrollTo(0, 0)
    }, 250)
}